import { ReactNode } from "react";
import { Button } from "@allaria-tech/matter/Button";

import SuccessIcon from "../../assets/images/icons/alert/success.svg";
import ErrorIcon from "../../assets/images/icons/alert/error-cross.svg";
import Warning from "../../assets/images/icons/alert/warning.svg";
import Info from "../../assets/images/icons/alert/info.svg";

import styles from "./feedbackCard.module.scss";

export type FeedbackCardType =
  | "success"
  | "error"
  | "warning"
  | "info"
  | "notice";

export interface FeedbackCardProps {
  type: FeedbackCardType;
  title: string;
  description: string | ReactNode;
  buttonText?: string;
  onButtonClick?: () => void;
  className?: string;
  secondaryButtonText?: string;
  onSeccondaryButtonClick?: () => void;
  maxWidth?: number;
  loading?: boolean;
  descriptionIsNode?: boolean;
  icon?: string;
}

const ICONS = {
  success: <img src={SuccessIcon} className={styles.icon} />,
  error: <img src={ErrorIcon} className={styles.icon} />,
  warning: <img src={Warning} className={styles.icon} />,
  info: <img src={Info} className={styles.icon} width={103} height={103} />,
  notice: <img src={Info} className={styles.icon} width={103} height={103} />,
};

const FeedbackCard = (props: FeedbackCardProps) => {
  const {
    type,
    title,
    description,
    buttonText,
    onButtonClick,
    onSeccondaryButtonClick,
    secondaryButtonText,
    loading,
    descriptionIsNode,
    icon: iconSource,
  } = props;

  const stateClasses: Record<FeedbackCardType, string> = {
    success: styles.success,
    error: styles.error,
    warning: styles.warning,
    info: styles.info,
    notice: styles.notice,
  };
  return (
    <div className={styles.bodyWrapper}>
      <div>
        {iconSource ? (
          <img src={iconSource} className={styles.icon} />
        ) : (
          ICONS[type]
        )}
        <h2 className={stateClasses[type]}>{title}</h2>
        {descriptionIsNode ? (
          description
        ) : (
          <p>{description}</p>
        )}
      </div>
      {buttonText && (
        <div className={styles.buttonGroup}>
          <Button
            text={buttonText}
            type="button"
            variant="primary"
            onClick={onButtonClick}
            isLoading={loading}
          />
          {secondaryButtonText && (
            <Button
              text={secondaryButtonText}
              type="button"
              variant="secondary"
              onClick={onSeccondaryButtonClick}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default FeedbackCard;
